import {
  DELETE_ECI_NOTIFICATION,
  GET_ECI_NOTIFICATIONS,
  GET_ECI_NOTIFICATIONS_BY_FYE,
  POST_ECI_NOTIFICATION,
  PUT_ECI_NOTIFICATION,
  UPDATE_ECI_EMAIL_STATUS,
  SET_ECI_FYE_FILTER,
  GET_CUSTOMERS_BY_FYE,
  BULK_CREATE_ECI_NOTIFICATIONS,
} from "../constants/actionTypes";

const defaultState = {
  eciNotificationsList: [],
  eciNotification: {},
  fyeFilter: {
    month: null,
    year: null
  },
  assessmentYear: null,
  lastBulkSendResult: null,
  customersByFYE: [],
  bulkCreateResult: null
};

export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_ECI_NOTIFICATIONS:
        return { ...state, eciNotificationsList: [...action.payload] };
      
      case GET_ECI_NOTIFICATIONS_BY_FYE:
        return { 
          ...state, 
          eciNotificationsList: [...action.payload.results],
          assessmentYear: action.payload.assessmentYear,
          fyeFilter: {
            month: action.payload.fyeMonth,
            year: action.payload.fyeYear
          }
        };
      
      case SET_ECI_FYE_FILTER:
        return {
          ...state,
          fyeFilter: action.payload
        };
      
      case POST_ECI_NOTIFICATION:
        return {
          ...state,
          eciNotificationsList: [...state?.eciNotificationsList, action.payload]
        };
      
      case PUT_ECI_NOTIFICATION:
        let data = [...state?.eciNotificationsList];
        const index = data?.findIndex(
          (notification) => notification?.id === action.payload?.id,
        );
        if (index !== -1) {
          data[index] = { ...action?.payload };
        }
        return { ...state, eciNotificationsList: [...data] };
      
      case UPDATE_ECI_EMAIL_STATUS:
        const updatedList = state.eciNotificationsList.map(notification => {
          if (notification.id === action.payload.eciId) {
            return {
              ...notification,
              email_status: action.payload.emailStatus,
              last_email_sent_date: action.payload.lastEmailSentDate
            };
          }
          return notification;
        });
        return { ...state, eciNotificationsList: updatedList };
      
      case DELETE_ECI_NOTIFICATION:
        const updatedArr = state.eciNotificationsList.filter(
          (notification) => notification.id !== action.payload,
        );
        return { ...state, eciNotificationsList: [...updatedArr] };
      
      case GET_CUSTOMERS_BY_FYE:
        return { 
          ...state, 
          customersByFYE: [...action.payload.customers],
          assessmentYear: action.payload.assessmentYear,
          fyeFilter: {
            month: action.payload.fyeMonth,
            year: action.payload.fyeYear
          }
        };
      
      case BULK_CREATE_ECI_NOTIFICATIONS:
        return {
          ...state,
          bulkCreateResult: action.payload
        };
      
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
